import { Component, Input } from "@angular/core";

import { BaseSearchResultsModel } from "../../../models/base-search-results.model";
import { DirectoryItemModel } from "../../models/directory-item.model";

@Component({
    selector: "pcg-ng-directory-search-results-list-view",
    templateUrl: "./directory-search-results-list-view.component.html"
})
export class DirectorySearchResultsListViewComponent {
    @Input() public searchResult: BaseSearchResultsModel<DirectoryItemModel>;
    @Input() public viewPageUrl: string;
    @Input() public defaultImageUrl: string;
}
